<template>
    <div class="listing-header default">
        <div class="row">

            <div class="col-12 col-md-9 col-sm-12 col-xs-12">
                <ul class="listing-sort nav nav-tabs justify-content-center" role="tablist" data-label="مرتب‌سازی بر اساس :">
                    <!--<li @click="orderByEvent(0)">
                <a data-toggle="tab" role="tab" aria-expanded="true" :class="{active: orderBy == 0 , show: orderBy == 0 }" aria-selected="false">پیش فرض</a>
            </li>-->
                    <li @click="orderByEvent(5)">
                        <a data-toggle="tab" role="tab" aria-expanded="false" :class="{active: orderBy == 5 , show: orderBy == 5 }" aria-selected="true">جدیدترین</a>
                    </li>
                    <li @click="orderByEvent(1)">
                        <a data-toggle="tab" role="tab" aria-expanded="false" :class="{active: orderBy == 1 , show: orderBy == 1 }" aria-selected="false">ارزان ترین</a>
                    </li>
                    <li @click="orderByEvent(2)">
                        <a data-toggle="tab" role="tab" aria-expanded="true" :class="{active: orderBy == 2 , show: orderBy == 3 }" aria-selected="false">گرانترین</a>
                    </li>
                    <li @click="orderByEvent(3)">
                        <a data-toggle="tab" role="tab" aria-expanded="false" :class="{active: orderBy == 3 , show: orderBy == 3 }" aria-selected="true">‌بیشترین تخفیف دار</a>
                    </li>
                    <li @click="orderByEvent(4)">
                        <a data-toggle="tab" role="tab" aria-expanded="false" :class="{active: orderBy == 4 , show: orderBy == 4 }" aria-selected="true">‌حروف الفبا</a>
                    </li>

                </ul>

            </div>
            <div class="col-12 col-md-3 col-sm-12 col-xs-12">
                <div class="fio-check">
                    <div style="margin-top:10px;text-align:left;margin-bottom:10px;">

                        <div class="custom-control custom-switch">
                            <input v-model="isAvalible" @change="isAvalibleEvent" type="checkbox" class="custom-control-input" id="customSwitch1">
                            <label class="custom-control-label" for="customSwitch1">فقط کالا های موجود</label>
                        </div>
                        <!--<label class="checkbox-form checkbox-primary">
                    <input v-model="isAvalible" @change="isAvalibleEvent" type="checkbox">
                    <span class="checkbox-check"></span>
                </label>
                <label for="agree-IsAvailable">
                    فقط کالا های موجود
                </label>-->
                    </div>
                </div>
            </div>
            <!--<div class="col-12 page-f col-md-6 col-sm-12 col-xs-12">-->
                <!--<paging></paging>-->
            <!--</div>-->
        </div>
    </div>
</template>

<script>
    import { filterEventBus } from "../../eventBus/eventBus";
    import paging from './paging.vue'
    export default {
        data() {
            return {
                orderBy: 5,
                isAvalible: false
            }
        },
        components: {
           
            'paging': paging,
            
        },
        watch: {
            $route: function (to, from) {
                this.$parent.$data.isAvalible = this.$route.query.IsAvalible == 'true' ? true : false;
                //this.$parent.$data.orderBy = IsNullOrEmptyString(this.$route.query.OrderBy) ? 5 : this.$route.query.OrderBy;
            },

        },
        methods: {
            isAvalibleEvent() {
                this.$parent.$data.isAvalible = this.isAvalible;
                filterEventBus.$emit('createQueryStringParameter');
            },
            orderByEvent(typeOFOrder) {
                this.$parent.$data.orderBy = typeOFOrder;
                this.$parent.$data.isAvalible = this.isAvalible;
                filterEventBus.$emit('createQueryStringParameter');
            },
        },
        created() {
            filterEventBus.$on('initializOrderBy', () => {
                this.orderBy = IsNullOrEmptyString(this.$route.query.OrderBy) ? 5 : this.$route.query.OrderBy;
                this.$parent.$data.orderBy = this.orderBy;
            });
            filterEventBus.$on('initializIsAvalible', () => {
                this.isAvalible = this.$route.query.IsAvalible == 'true' ? true : false;
            });
        },
        beforeDestroy() {
            filterEventBus.$off('initializOrderBy');
            filterEventBus.$off('initializIsAvalible');
        }
    }
</script>

<style scoped>
  
   

    .custom-switch {
        padding-left: 2.25rem;
    }

    .custom-control {
        position: relative;
        z-index: 1;
        display: block;
        min-height: 1.5rem;
        padding-left: 1.5rem;
        -webkit-print-color-adjust: exact;
        color-adjust: exact;
        print-color-adjust: exact;
    }

    .custom-control-input {
        position: absolute;
        left: 0;
        z-index: -1;
        width: 1rem;
        height: 1.25rem;
        opacity: 0;
    }

    
    .custom-control-label::after {
        position: absolute;
        top: .25rem;
        left: -1.5rem;
        display: block;
        width: 1rem;
        height: 1rem;
        content: "";
        background: 50%/50% 50% no-repeat;
        background-color: rgba(0, 0, 0, 0);
    }
    .custom-switch .custom-control-label::before {
        left: -2.25rem;
        width: 2.4rem;
        pointer-events: all;
        border-radius: .5rem;
    }

    .custom-control-label::before, .custom-file-label, .custom-select {
        transition: background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    }
    .custom-control-label::before {
        position: absolute;
        top: .25rem;
        left: -1.5rem;
        display: block;
        width: 1rem;
        height: 1rem;
        pointer-events: none;
        content: "";
        background-color: #fff;
        border: 1px solid #adb5bd;
    }
    .custom-control-label {
        position: relative;
        margin-bottom: 0;
        vertical-align: top;
    }
    .custom-switch .custom-control-label::before {
        left: -2.25rem;
        width: 1.98rem;
        pointer-events: all;
        border-radius: .5rem;
    }

    .custom-control-label::before, .custom-file-label, .custom-select {
        transition: background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    }

    .custom-control-label::before {
        position: absolute;
        top: .25rem;
        left: -1.5rem;
        display: block;
        width: 1rem;
        height: 1.1rem;
        pointer-events: none;
        content: "";
        background-color: #fff;
        border: 1px solid #adb5bd;
    }
    .custom-switch .custom-control-label::after {
        top: calc(.25rem + 2px);
        left: calc(-2.25rem + 2px);
        width: calc(1rem - 2px);
        height: calc(1rem - 2px);
        background-color: #adb5bd;
        border-radius: .5rem;
        transition: background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-transform .15s ease-in-out;
        transition: transform .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
        transition: transform .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-transform .15s ease-in-out;
    }

    .custom-control-label::after {
        position: absolute;
        top: .25rem;
        left: -1.5rem;
        display: block;
        width: 1rem;
        height: 1rem;
        content: "";
        background: 50%/50% 50% no-repeat;
        background-color: rgba(0, 0, 0, 0);
    }

    .custom-switch .custom-control-input:checked ~ .custom-control-label::after {
        background-color: #fff;
        -webkit-transform: translateX(.75rem);
        transform: translateX(.75rem);
    }

     
    .custom-control-label::after {
        position: absolute;
        top: .25rem;
        left: -1.5rem;
        display: block;
        width: 1rem;
        height: 1rem;
        content: "";
        background: 50%/50% 50% no-repeat;
        background-color: rgba(0, 0, 0, 0);
    }









    .page-f #productPaging {
        margin-bottom:0;
    }
    .page-f .pager-items {
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .page-f .pager-page {
        display:flex;
        justify-content:center;
        align-items:center;
     
    }
    .page-f #productPaging ul li a {
        font-size: 17px !important;
    }
    
    .listing-header:before {
        content: unset !important;
    }
    .fio-check {
        margin-left: 25px;
    }
        .fio-check label{
            margin-bottom:0;
        }
        .fio-check .form-account-agree {
            margin-top: 5px;
        }
    .bx-jh {
        display: flex;
        justify-content: right;
    }
    .l-f-ppp {
        margin:unset;
        float: left;
    }
    .form-account-agree {
 
        margin: unset;
    }
    @media only screen and (min-width: 0px) and (max-width: 640px) {
        .l-f-ppp {
            float: right !important;
            margin-right: 15px !important;
        }
        ul li a:active:hover, ul li a:focus {
            color: #fff !important;
        }

        .listing-sort li a {
            padding: 5px;
            border-radius: unset;
        }

        .listing-header::before {
            top: 10%;
        }

        .listing-header {
            padding: 10px 0 0 0;
        }

        .listing-sort li + li {
            margin-right: 0;
        }

        .listing-sort li {
            display: block;
        }

        .form-account-agree {
            margin: auto;
        }
    }

    ul li a {
        cursor: pointer;
    }
</style>